<template>
  <div class="ai-message-unit" :class="`message-type-${type}`">
    <div class="message-header">
      <span class="sender-label">{{ senderLabel }}</span>
    </div>
    <div class="message-content">
      <div class="message-bubble-wrapper" :class="{ 'align-right': type === 'user' }">
        <div v-if="type !== 'user' && type !== 'error'" class="message-tail left-tail"></div>
        <div class="message-bubble" :class="bubbleClass">
          <p class="message-text">{{ message.text }}</p>
        </div>
        <div v-if="type === 'user'" class="message-tail right-tail"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIMessageUnit',
  props: {
    message: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ['ai', 'user', 'error'].includes(value)
    }
  },
  computed: {
    senderLabel() {
      if (this.type === 'ai') return 'AI Assistant:';
      if (this.type === 'user') return 'Me';
      return 'Error';
    },
    bubbleClass() {
      console.log('bubbleClass', this.type);
      return {
        'ai-bubble': this.type === 'ai',
        'user-bubble': this.type === 'user',
        'error-bubble': this.type === 'error'
      };
    }
  }
};
</script>

<style scoped>
.ai-message-unit {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.message-type-user {
  align-items: flex-end;
}

.message-header {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 32px;
}

.message-type-user .message-header {
  justify-content: flex-end;
}

.sender-label {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.25px;
}

.message-type-ai .sender-label,
.message-type-error .sender-label {
  font-weight: 700;
  color: #666;
}

.message-type-user .sender-label {
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #333;
}

.message-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 32px;
}

.message-bubble-wrapper {
  display: flex;
  align-items: center;
  padding-right: 6px;
  width: 100%;
}

.message-bubble-wrapper.align-right {
  justify-content: flex-end;
  padding-right: 0;
  padding-left: 6px;
}

.message-tail {
  width: 20.114px;
  height: 21.528px;
  position: relative;
  flex-shrink: 0;
}

.left-tail {
  margin-right: -6px;
}

.right-tail {
  margin-left: -6px;
}

.left-tail::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(15deg);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 18px solid #E4F3F5;
}

.right-tail::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(165deg) scaleY(-1);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 18px solid #F2F2F2;
}

.message-bubble {
  flex: 1;
  border-radius: 20px;
  padding: 12px 24px;
  word-wrap: break-word;
}

.ai-bubble {
  background: #E4F3F5;
  margin-right: -6px;
  margin-left: -2px;
}

.user-bubble {
  background: #F2F2F2;
  margin-left: -6px;
  max-width: fit-content;
  margin-right: -2px;
}

.error-bubble {
  background: #FAEAEA;
  border: 1px solid #D10000;
  margin-right: -6px;
}

.message-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin: 0;
  white-space: pre-wrap;
}

.ai-bubble .message-text,
.error-bubble .message-text {
  color: #666;
  text-align: left;
}

.user-bubble .message-text {
  color: #333;
}

.error-bubble .message-text {
  color: #D10000;
}
</style>
